import { BillLinIncomeSchema } from './bill-lin-income'
import { BillLinExpenseSchema } from './bill-lin-expense'
import { BillLinReceivableSchema } from './bill-lin-receivable'
import { BillLinReceivableAddressSchema } from './bill-lin-receivable-address'
import { BillLinReceivableSlipSchema } from './bill-lin-receivable-slip'
import { BillLinReceivableInactiveSchema } from './bill-lin-receivable-inactive'
import type { WorkerSchema } from '../types'

export const WORKER_SCHEMAS: Record<string, WorkerSchema> = {
  'bill-lin-income': BillLinIncomeSchema,
  'bill-lin-expense': BillLinExpenseSchema,
}

export const RECEIVABLE_SCHEMAS: Record<string, WorkerSchema> = {
  'bill-lin-receivable-address': BillLinReceivableAddressSchema,
  'bill-lin-receivable-slip': BillLinReceivableSlipSchema,
  'bill-lin-receivable': BillLinReceivableSchema,
  'bill-lin-receivable-inactive': BillLinReceivableInactiveSchema,
}

export function defineSchema(schema: WorkerSchema): WorkerSchema {
  return schema
}

export {
  BillLinIncomeSchema,
  BillLinExpenseSchema,
  BillLinReceivableSchema,
  BillLinReceivableAddressSchema,
  BillLinReceivableSlipSchema,
  BillLinReceivableInactiveSchema,
}
